import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { useRef, useEffect } from 'react';
import { Notification } from '@mantine/core';
import getAutoClose from './get-auto-close/get-auto-close.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

function NotificationContainer(_a) {
  var _b = _a,
      notification = _b.notification,
      autoClose = _b.autoClose,
      onHide = _b.onHide,
      innerRef = _b.innerRef,
      others = __objRest(_b, ["notification", "autoClose", "onHide", "innerRef"]);

  var _a2 = notification,
      notificationAutoClose = _a2.autoClose,
      message = _a2.message,
      notificationProps = __objRest(_a2, ["autoClose", "message"]);

  var autoCloseTimeout = getAutoClose(autoClose, notificationAutoClose);
  var hideTimeout = useRef();

  var handleHide = function handleHide() {
    onHide(notification.id);
    window.clearTimeout(hideTimeout.current);
  };

  var cancelDelayedHide = function cancelDelayedHide() {
    clearTimeout(hideTimeout.current);
  };

  var handleDelayedHide = function handleDelayedHide() {
    if (typeof autoCloseTimeout === "number") {
      hideTimeout.current = window.setTimeout(handleHide, autoCloseTimeout);
    }
  };

  useEffect(function () {
    if (typeof notification.onOpen === "function") {
      notification.onOpen(notification);
    }
  }, []);
  useEffect(function () {
    handleDelayedHide();
    return cancelDelayedHide;
  }, [autoClose, notification.autoClose]);
  return /* @__PURE__ */React.createElement(Notification, __spreadProps(__spreadValues(__spreadValues({}, notificationProps), others), {
    onClose: handleHide,
    onMouseEnter: cancelDelayedHide,
    onMouseLeave: handleDelayedHide,
    ref: innerRef
  }), message);
}

NotificationContainer.displayName = "@mantine/notifications/NotificationContainer";
export default NotificationContainer;